import { ArrowRight, Sparkles, ShieldCheck, Zap } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { IMAGES, scrollToId } from "@/lib/content";
import { buildWhatsAppLink, GENERIC_WA_MESSAGE } from "@/lib/whatsapp";
import { track } from "@/lib/track";

export const Hero = () => (
  <section id="home" className="relative overflow-hidden bg-white">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 pt-12 lg:grid-cols-12 lg:gap-10 lg:px-8 lg:pb-28 lg:pt-20">
      <div className="fade-up lg:col-span-6">
        <span className="eyebrow"><Sparkles className="h-3.5 w-3.5" /> Energia pulita per la tua casa e la tua azienda</span>
        <h1 data-testid="hero-title" className="mt-6 text-4xl font-semibold leading-[1.05] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
          Piattaforma CRM Fotovoltaico <span className="text-emerald-600">con Apollo.AI</span>
        </h1>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
          Progettiamo e installiamo impianti fotovoltaici su misura. Con l'analisi satellitare dei tetti di Apollo.AI ottieni un preventivo solare istantaneo, senza sopralluogo per la prima stima.
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <button
            data-testid="hero-cta-calculator-button"
            onClick={() => { track("click_calcola_hero"); scrollToId("calcolatore-ai"); }}
            className="group inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 px-6 py-3.5 font-semibold text-slate-900 shadow-lg shadow-emerald-500/30 transition-colors hover:bg-emerald-400"
          >
            Calcola con Apollo.AI
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <a
            data-testid="hero-cta-whatsapp-button"
            href={buildWhatsAppLink(GENERIC_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("click_whatsapp", { position: "hero" })}
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-6 py-3.5 font-semibold text-slate-800 transition-colors hover:border-emerald-300 hover:text-emerald-700"
          >
            <WhatsAppIcon className="h-5 w-5 text-[#25D366]" /> Scrivici su WhatsApp
          </a>
        </div>
        <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-500">
          <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-600" /> Sopralluogo gratuito</span>
          <span className="flex items-center gap-2"><Zap className="h-4 w-4 text-emerald-600" /> Proposta in 48 ore</span>
        </div>
      </div>
      <div className="relative fade-up lg:col-span-6" style={{ animationDelay: "120ms" }}>
        <div className="overflow-hidden rounded-3xl border border-slate-200">
          <img src={IMAGES.hero} alt="Tetto con pannelli solari" className="aspect-[4/3] w-full object-cover lg:aspect-[5/4]" />
        </div>
        <div className="absolute -bottom-6 left-4 rounded-2xl border border-white/60 bg-white/80 px-5 py-4 shadow-xl backdrop-blur-xl sm:left-8">
          <p className="text-xs font-medium uppercase tracking-widest text-slate-500">Apollo.AI</p>
          <p className="font-display text-lg font-semibold text-slate-900">Stima del tuo impianto in 10 secondi</p>
        </div>
      </div>
    </div>
  </section>
);
